import { TaskUnassignReason } from "@quickcommerceltd/zephyr-types";

export const TASK_UNASSIGN_REASONS: TaskUnassignReason[] = [
  "ACCIDENTALLY_REQUESTED",
  "RIDER_DID_NOT_SHOW_UP",
  "RIDER_ETA_TOO_LATE",
  "OOS_ITEM",
  "OTHER",
];
